import React, { useEffect, useRef } from "react";

function WatchTutorialModel({ videoSrc }) {
  const videoRef = useRef(null);

  useEffect(() => {
    // Get the modal element
    const modal = document.getElementById("WatchTutorialModal");

    // Function to stop video
    const stopVideo = () => {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    };

    // Add event listener for when modal is hidden
    const handleModalClose = () => {
      stopVideo();
    };

    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleModalClose);

      // Cleanup function
      return () => {
        modal.removeEventListener("hidden.bs.modal", handleModalClose);
      };
    }
  }, []);
  return (
    <div
      className="modal fade"
      id="WatchTutorialModal"
      tabIndex="-1"
      aria-labelledby="WatchTutorialModalLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-scrollable"
        style={{ maxWidthwidth: "80%" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="WatchTutorialModalLabel">
              Watch Tutorial
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <video
              width="640"
              height="320"
              controls
              style={{ maxWidth: "100%" }}
              ref={videoRef}
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WatchTutorialModel;
